import axios from 'axios';

axios.defaults.baseURL = 'https://pixabay.com/api/';

const API_KEY = '43800208-301c21487611dae4b6f535cf2';

export const PER_PAGE = 15;

export const getImagesByQuery = async (query, page) => {
  const { data } = await axios.get('', {
    params: {
      key: API_KEY,
      q: query,
      image_type: 'photo',
      orientation: 'horizontal',
      safesearch: true,
      per_page: PER_PAGE,
      page,
    },
  });

  return data;
};
